/**
 * The composer's focus request, as a monotonic token (PRD-0271 D-5).
 *
 * Each request wakes the composer, including when already focused. Consumption
 * survives unmounts: a shortcut can request focus before Home mounts, but an
 * ordinary return to Home must not replay an old request and bypass navigation.
 *
 * Deliberately a store and not a context: the shortcut is bound in AppLayout
 * and the textarea lives several routes down, and neither should have to
 * thread a callback through the tree to meet the other.
 *
 * @module hooks/useComposerFocus
 */

import { create } from 'zustand'

interface ComposerFocusState {
  token: number
  consumedToken: number
  request: () => void
  consumeRequest: () => boolean
}

export const useComposerFocus = create<ComposerFocusState>()((set, get) => ({
  token: 0,
  consumedToken: 0,
  request: () => set((state) => ({ token: state.token + 1 })),
  consumeRequest: () => {
    const { token, consumedToken } = get()
    if (token === consumedToken) return false
    set({ consumedToken: token })
    return true
  },
}))
